/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable */
import {
	useState, useReducer, useEffect,
	useMemo
} from 'react';
import { InputPicker, Toggle } from 'rsuite';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux';
import { CreatePageHeader } from '@/Components/Headers';
import { BackdropLoader } from '@/Components/Loaders';
import { formActions } from '@/Actions';
import { config } from './processStateConfig';
import processConfigServices from '@/Services/process.config';
import { notificationServices } from '@/Services';

function ProcessConfig(props) {
	const {
		storesList,
		processTypes,
		fetchStoresList,
		fetchProcessTypesList,
	} = props;
	const [isLoading, setIsloading] = useState(false);
	const isEdit = false;
	const history = useHistory();
	const [state, dispatch] = useReducer(config?.reducer, config?.initialState);
	const {
		store,
		processId,
		qualityControl,
		overrideAllowed,
		supervisorControl,
		duplicateAllowed,
		duplicateControl,
		leftOverInventory,
		combineCMSBatches,
		cmsIngPrint,
		containerInBulkMode,
		containerOnProcess,
		isOpenInventory,
	} = state;

	const handleSubmit = async () => {
		const valid = config?.validator(state);
		if (valid) {
			setIsloading(true);
			try {
				const deserializedData = config?.deserializer(state);
				const req = {
					data: deserializedData,
				};
				const response = await processConfigServices?.createProcessConfig(req);
				if (response?.statusCode === 200) {
					notificationServices.generateNotification({
						type: 'success',
						message: response?.message,
					});
					setIsloading(false);
					// history.goBack();
					// dispatch({
					// type: 'SET_VALUE',
					// payload: {
					// ...config?.initialState,
					// },
					// });
				} else {
					setIsloading(false);
					notificationServices.generateNotification({
						type: 'error',
						message: response?.message,
					});
				}
			} catch (err) {
				setIsloading(false);
				notificationServices.generateNotification({
					type: 'error',
					message: err,
				});
			}
		}
	};
	const handleBackClick = () => {
		history.goBack();
	};
	const renderBtns = () => {
		return (
			<Button
				variant='contained'
				color='primary'
				type='button'
				onClick={handleSubmit}
			>
				Save
			</Button>
		);
	};
	useEffect(() => {
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	useEffect(() => {
		if (store) {
			fetchProcessTypesList({
				entity: 'PROCESS_TYPES',
				req: {
					params: {
						id: '',
						storeId: store,
					},
				},
				method: 'LIST',
			});
		}
	}, [store]);
	const fetchUser = async () => {
		try {
			setIsloading(true);
			const response = await processConfigServices.createProcessConfig({
				params: {
					processId,
				},
			}, 'GET');
			if (response?.statusCode === 200) {
				const userData = response?.data;
				notificationServices.generateNotification({
					type: 'success',
					message: response?.message,
				});
				dispatch({
					type: 'SET_VALUE',
					payload: {
						qualityControl: userData?.qualityControl,
						overrideAllowed: userData?.overrideAllowed,
						supervisorControl: userData?.supervisorControl,
						duplicateAllowed: userData?.duplicateAllowed,
						duplicateControl: userData?.duplicateControl,
						leftOverInventory: userData?.leftOverInventory,
						combineCMSBatches: userData?.combineCMSBatches,
						cmsIngPrint: userData?.cmsIngPrint,
						containerInBulkMode: userData?.containerInBulkMode,
						containerOnProcess: userData?.containerOnProcess,
						isOpenInventory: userData?.isOpenInventory,
					},
				});
			}
		} catch (error) {
			notificationServices.generateNotification({
				type: 'error',
				message: 'Problem in process config',
			});
			// eslint-disable-next-line no-console
			// console.log(error);
		} finally {
			setIsloading(false);
		}
	};

	useEffect(() => {
		if (processId) {
			fetchUser();
		}
	}, [processId]);
	const opreationProcess = useMemo(() => {
		// const processData = processTypes?.filter((item) => item?.data?.type === 'OPERATION');
		const data = [
			...processTypes?.map((item) => {
				return {
					label: item?.data?.heading,
					value: item?.id,
				};
			}),
		];
		return data;
	}, [processTypes]);

	return (
		<>
			<BackdropLoader showProgress isLoading={isLoading} />
			<CreatePageHeader
				handleSubmit={handleSubmit}
				showCancel={false}
				heading={`${isEdit ? 'Edit' : 'Create'} Process Config`}
				renderBtns={renderBtns}
				showBack
				handleBackClick={handleBackClick}
			/>
			<div className='mx-3 my-3 flex flex-col gap-6'>
				{/* Selectors Section */}
				<div className='flex flex-wrap gap-8 items-end'>
					<div className='flex flex-col gap-2'>
						<label className='text-base text-red-600 font-medium'> Select Store*</label>
						<InputPicker
							data={storesList?.map((item) => ({
								label: item?.name,
								value: item?.id,
							}))}
							value={store}
							placeholder='Enter the Store'
							onSelect={(val) => {
								dispatch({
									type: 'SET_VALUE',
									payload: { store: val },
								});
							}}
							className='w-64'
						/>
					</div>
					<div className='flex flex-col gap-2'>
						<label className='text-base text-red-600 font-medium'> Select Process*</label>
						<InputPicker
							data={opreationProcess}
							value={processId}
							placeholder='Select Process'
							onSelect={(val) => {
								dispatch({
									type: 'SET_VALUE',
									payload: { processId: val },
								});
							}}
							className='w-64'
						/>
					</div>
				</div>

				{/* Toggles Grid Section */}
				<div className='flex flex-col gap-4'>
					<h3 className='text-[15px] font-bold text-slate-800 flex items-center gap-2'>
						<div className='w-1 h-5 bg-[#ffb703] rounded-full'></div>
						Configuration Settings
					</h3>

					<div className='grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-1'>
						{[
							{ id: 'qualityControl', label: 'Quality Control', value: qualityControl },
							{ id: 'overrideAllowed', label: 'Quality Override', value: overrideAllowed },
							{ id: 'duplicateControl', label: 'Duplicate Control', value: duplicateControl },
							{ id: 'duplicateAllowed', label: 'Duplicate Override', value: duplicateAllowed },
							{ id: 'supervisorControl', label: 'Supervisor Control', value: supervisorControl },
							{ id: 'leftOverInventory', label: 'Left Over Inventory', value: leftOverInventory },
							{ id: 'combineCMSBatches', label: 'Combine CMS Batches', value: combineCMSBatches },
							{ id: 'cmsIngPrint', label: 'CMS Ingredient Print', value: cmsIngPrint },
							{ id: 'containerInBulkMode', label: 'Container In Bulk Mode', value: containerInBulkMode },
							{ id: 'containerOnProcess', label: 'Container On Process', value: containerOnProcess },
							{ id: 'isOpenInventory', label: 'Open Inventory', value: isOpenInventory },
						].map((configItem) => (
							<div
								key={configItem.id}
								className='flex justify-between items-center py-3 px-3 hover:bg-slate-50 transition-all duration-200 group rounded-lg'
							>
								<label
									htmlFor={configItem.id}
									className='text-[14px] text-slate-600 font-medium group-hover:text-slate-900 transition-colors cursor-pointer'
								>
									{configItem.label}
								</label>
								<Toggle
									id={configItem.id}
									name={configItem.id}
									size='sm'
									checked={configItem.value}
									onChange={(checked) => {
										dispatch({
											type: 'SET_VALUE',
											payload: { [configItem.id]: checked },
										});
									}}
								/>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	);
}
const mapStateToProps = (state) => {
	const { userPermissions } = state.navigation;
	const storesList = state?.form?.STORES?.data?.LIST;
	const { LIST: processTypes } = state?.form?.PROCESS_TYPES?.data;

	return {
		userPermissions,
		storesList,
		processTypes,
	};
};

const mapDispatchToProps = {
	fetchStoresList: formActions.gateway,
	fetchProcessTypesList: formActions.gateway,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessConfig);
